import DateRangePicker from "../../../vendor/assets/javascripts/daterangepicker";

globalThis.DateRangePicker = DateRangePicker;
